import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Breadcrumbs } from '../models/breadcrumbs.models';
import { InitBreadcrumbs } from '../store/breadcrumbs.actions';
import { getBreadcrums } from '../store/breadcrumbs.selectors';

import { ProductPublicModels } from '@features/products/product';
import { GoToSection } from '@shared/navigation';

@Component({
    selector: 'breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbsComponent implements OnChanges {
    @Input() public categoryId: string;

    @Input() public product: ProductPublicModels.PublicProduct;

    public breadcrumbs$: Observable<Breadcrumbs> = this.store.select(getBreadcrums);

    constructor(
        private readonly store: Store,
    ) {}

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes.categoryId || changes.product) {
            this.initBreadcrumbs();
        }
    }

    public navigate(event, url) {
        event.preventDefault();
        this.store.dispatch(GoToSection({ url: url }));
    }

    public initBreadcrumbs(): void {
        this.store.dispatch(InitBreadcrumbs({ categoryId: this.categoryId, product: this.product }));
    }

    public trackByIndex(index: number): number {
        return index;
    }
}
